<template>
    <comp-9-prep-adherence :section="9" :page="44">
        <p class="headline text-xs-center">Let’s Review</p>
        <p>
            We have learned a lot in this activity, like that you’re committed to doing what you can to protect yourself from getting HIV and that taking PrEP
            is important to you because:
        </p>
        <ul>
            <li v-for="motivator in prepChangeMotivators" :key="motivator.id">{{ motivator.userEntered ? motivator.response : motivator.text }}</li>
        </ul>
        <br />
        <p>
            We were reminded that taking PrEP a minimum of 4 days a week and up to everyday is the most reliable way to protect ourselves against HIV when
            having sex. In order to support you taking PrEP at least 4 days a week, we identified strategies that can help remind you to take your PrEP. These
            strategies include:
        </p>
        <ul>
            <li v-for="strategy in prepStrategies" :key="strategy.id">{{ strategy.userEntered ? strategy.response : strategy.text }}</li>
        </ul>
        <br />
        <p>
            Yassss! You’ve got it. I believe in you!
        </p>
        <div v-if="!artVisited">
            <p>Do you want to visit the ART adherence resources?</p>
            <v-layout row wrap justify-center my-3>
                <v-flex xs6>
                    <div @click.prevent="viewArt()" class="diagram-chip fact">
                        <v-chip color="primary" text-color="white" class="py-2" v-ripple>ART Resources</v-chip>
                        <div class="check" v-if="artVisited">
                            <v-avatar class="success">
                                <v-icon dark>check</v-icon>
                            </v-avatar>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </comp-9-prep-adherence>
</template>

<script>
import { filter } from 'lodash';
import { get } from 'vuex-pathify';
import router from '@/router';

export default {
    computed: {
        prepChangeMotivators() {
            return filter(this.$store.get('section9/prepMotivatorsRevisited'), 'selected');
        },
        prepStrategies() {
            return filter(this.$store.get('section9/prepRegularStrategiesRevisited'), 'selected');
        },
        artVisited: get('section9/artVisited'),
        firstArtScreen: get('section9/firstArtScreen')
    },
    methods: {
        viewArt() {
            // go to the first ART Adherence screen
            router.push(`/page/9/${this.firstArtScreen}`);
        }
    }
};
</script>

<style scoped>
.fact {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.visited {
    opacity: 0.5;
}
</style>
